import { drivers } from '../config';
export = drivers.oracledb;
